import { chakra } from '@stockx/ui';

export const SubMenuContainer = chakra('div', {
  baseStyle: {
    height: '100vh',
    overflowY: 'scroll',
    padding: '24px 16px',
  },
});

export const SubMenuTitle = chakra('span', {
  baseStyle: {
    fontSize: 'lg',
    letterSpacing: '-0.4px',
    lineHeight: 'xl',
    color: 'neutral.black',
  },
});

export const SubMenuLinkContainer = chakra('div', {
  baseStyle: {
    display: 'flex',
    flexDirection: 'column',
    height: '80%',
    marginTop: 4,
  },
});

// Rendering span here as a "wrapper" around the
// SwitcherLink component bc when you pass "as" prop
// chakra factory coerces the DOM element to <BROWSE> or <PRODUCT>
// and we don't want that.
export const SubMenuLink = chakra('span', {
  baseStyle: {
    position: 'relative',
    paddingLeft: 4,
    paddingTop: 2,
    fontSize: 'lg',
    fontWeight: 500,
    color: 'neutral.black',

    '&:last-of-type': {
      paddingBottom: '220px',
    },
    _hover: {
      color: 'green.700',
    },
    '&.decorated': {
      color: 'green.700',
    },
    '&.active': {
      color: 'green.700',
    },
  },
});

export const SubMenuFooter = chakra('div', {
  baseStyle: {
    position: 'fixed',
    bottom: 0,
    width: '100%',
    height: '10%',
    background: `linear-gradient(to top, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%)`,
  },
});

export const SubMenuItem = chakra('div', {
  baseStyle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
});

export const SubMenuItemTitle = chakra('div', {
  baseStyle: {
    fontSize: 'md',
    fontWeight: 500,
    padding: '8px 0px 8px 16px',
    cursor: 'pointer',
  },
});

export const Chevron = chakra('div', {
  baseStyle: {
    color: 'neutral.black',
    fontWeight: 500,
    marginRight: 4,
  },
});
